"use client";

import { useState } from "react";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";
import { testimonialsData } from "@/features/landing/data";

export default function LandingTestimonials() {
  const [current, setCurrent] = useState(0);

  const prev = () =>
    setCurrent((c) => (c === 0 ? testimonialsData.length - 1 : c - 1));
  const next = () =>
    setCurrent((c) => (c + 1) % testimonialsData.length);

  return (
    <section className="py-16 sm:py-20 bg-[#fafafa]">
      <div className="max-w-5xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-12">
          <p className="text-[11px] tracking-[0.25em] uppercase text-[#6b6b6b] font-winky mb-2">
            What people say
          </p>
          <h2 className="text-[1.75rem] sm:text-[2.5rem] font-bold text-[#2d2d2d] font-winky leading-tight">
            Loved by real users
          </h2>
        </div>

        {/* Testimonial Card */}
        <div className="max-w-3xl mx-auto relative">
          <div className="bg-white rounded-3xl border border-[#eee] shadow-md p-8 sm:p-12 min-h-[280px] flex flex-col">
            {/* Stars */}
            <div className="flex gap-1 mb-5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-[#ffd372] text-[#ffd372]" />
              ))}
            </div>

            {/* Review */}
            <p className="text-[#3a3a3a] text-[15px] sm:text-[17px] leading-[1.7] font-patrick flex-grow">
              &ldquo;{testimonialsData[current].review}&rdquo;
            </p>

            {/* Author */}
            <div className="mt-6 pt-5 border-t border-[#f0f0f0]">
              <p className="text-[#2d2d2d] font-bold text-[15px] font-winky">
                {testimonialsData[current].name}
              </p>
              <p className="text-[#767676] text-[12px] mt-0.5">
                {testimonialsData[current].details}
              </p>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-between mt-8">
            <button
              onClick={prev}
              aria-label="Previous review"
              className="p-3 rounded-full bg-white border border-[#e0e0e0] hover:border-[#2d2d2d] transition-all shadow-sm"
            >
              <ChevronLeft className="w-5 h-5 text-[#2d2d2d]" />
            </button>

            <div className="flex gap-2">
              {testimonialsData.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrent(index)}
                  className={`rounded-full transition-all duration-300 ${
                    current === index
                      ? "w-8 h-2.5 bg-[#ffd372]"
                      : "w-2.5 h-2.5 bg-[#ddd]"
                  }`}
                  aria-label={`Go to review ${index + 1}`}
                />
              ))}
            </div>

            <button
              onClick={next}
              aria-label="Next review"
              className="p-3 rounded-full bg-white border border-[#e0e0e0] hover:border-[#2d2d2d] transition-all shadow-sm"
            >
              <ChevronRight className="w-5 h-5 text-[#2d2d2d]" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
